/**
 * App Config File
 */
import Ossif_Logo from '../assets/img/OSSIF_logo.png'
import LogoABI from '../assets/img/logoABI.png'
import landingpage from '../assets/img/landingpage.png'
import sidebarLogo from '../assets/img/sidebar-4.jpg'
const AppConfig = {
  appLogoOssif: Ossif_Logo,
  appLogoABI: LogoABI,
  landingpage: landingpage, // App Logo ABI
  brandName: 'DB ANTICRIMINE di OSSIF', // Brand Name
  navCollapsed: false, // Sidebar collapse
  darkMode: false, // Dark Mode
  boxLayout: false, // Box Layout
  rtlLayout: false, // RTL Layout
  miniSidebar: false, // Mini Sidebar
  enableSidebarBackgroundImage: false, // Enable Sidebar Background Image
  sidebarImage: sidebarLogo, // Select sidebar image
  isDarkSidenav: true, // Set true to dark sidebar
  enableThemeOptions: true, // Enable Theme Options
  locale: {
    languageId: 'italian',
    locale: 'it',
    name: 'Italian',
    icon: 'it'
  },
  enableUserTour: process.env.NODE_ENV === 'production' ? true : false, // Enable / Disable User Tour
  //copyRightText: 'G&O srl © 2022 All Rights Reserved.',      // Copy Right Text
  copyRightText: '', // Copy Right Text
  // light theme colors
  themeColors: {
    primary: '#013668',
    primary_old: '#5D92F4',
    secondary: '#677080',
    success: '#00D0BD',
    danger: '#FF3739',
    warning: '#FFB70F',
    info: '#00D0BD',
    dark: '#464D69',
    default: '#FAFAFA',
    greyLighten: '#A5A7B2',
    grey: '#677080',
    white: '#FFFFFF',
    purple: '#896BD6',
    yellow: '#D46B08'
  },
  // dark theme colors
  darkThemeColors: {
    darkBgColor: '#424242'
  }
}

export default AppConfig
